<script lang="ts">
	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { onMount } from 'svelte';
	import { logger } from '../../../logger.ts';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';

	let { teaserContent, teaserSize }: {
		teaserContent: TeaserContent,
		teaserSize: string
	} = $props();

	let originUrl = $state('');
	let teaserUri = $state('');

	const customerIdentityGeneratorUrl = '/up-teaserui/gateway/generateCustomerIdentityLoginUrl';
	const teaserType = TeaserType.TO_LOGIN;

	let teaser: Element;
	let trackingService: TrackingService;
	onMount(() => {
		originUrl = window.location.href;
		trackingService = new TrackingService();

		fetch(`${customerIdentityGeneratorUrl}?originUrl=${originUrl}`, {
			credentials: 'include',
			method: 'GET',
			headers: { 'Content-Type': 'application/json' }
		}).then(response => {
			if (response.status === 200) {
				response.json().then(response => {
					teaserUri = response.encodedUrl;
					logger.debug(`Response ok - teaserUri: ${teaserUri}`);
				});
			} else {
				logger.error(`Status ${response.status} calling url generator`);
			}
		}).catch(error => {
			logger.error('Error generating url:' + error);
		});

		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize);
	});
</script>

<div bind:this={teaser}
	data-testid="to-login-teaser"
	id="teaser-container"
	class="oc-pt-150"
	onenterViewport={() => trackSeen(trackingService, teaser, teaserContent, teaserType, teaserSize)}
	use:onViewport
>
	<a href={teaserUri} id="to-login-link" style="all: unset">
		<oc-media-object-card-v1
			as-button=""
			background-color="#F0F0F0"
			data-testid="to-login-teaser-card"
			elevation-level="canvas"
			icon="otto-up"
			icon-color="#F00020"
			size="25"
			variant="icon"
            oc-aria-label="Anmeldung zum Vorteilsprogramm"
		>
			<div aria-hidden="true" id="headline" slot="headline">{teaserContent?.heading}</div>
			<div aria-hidden="true" id="subline" slot="subline">{teaserContent?.subheading}</div>
		</oc-media-object-card-v1>
	</a>

</div>
